import styled from "styled-components";
import { Button } from "reactstrap";

export const ModalWrapper = styled.div`
  --primary: #0c2b6e;
  --text: #172554;
  --muted: #64748b;
  --surface: #ffffff;
  --border: #e2e8f0;

  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;

  width: min(920px, calc(100vw - 32px));
  max-height: 90vh;
  overflow-y: auto;
  padding: 30px;

  background: var(--surface);
  border: 1px solid #e8edf5;
  border-radius: 20px;
  box-shadow: 0 24px 80px rgba(15, 23, 42, 0.22);

  font-family: inherit;
  color: var(--text);

  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;

  .modal-header {
    display: flex;
    align-items: center;
    gap: 16px;
    padding-bottom: 24px;
    border-bottom: 1px solid #edf1f7;
  }

  .header-icon {
    flex-shrink: 0;
    width: 52px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 16px;
    background: #eaf0ff;
    color: var(--primary);
    font-size: 21px;
  }

  .header-content {
    flex: 1;
    min-width: 0;
  }

  .eyebrow {
    display: block;
    margin-bottom: 5px;
    color: #6479a5;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 1.5px;
  }

  .header-content h2 {
    margin: 0;
    color: var(--primary);
    font-size: 25px;
    font-weight: 750;
    letter-spacing: -0.7px;
  }

  .header-content p {
    margin: 6px 0 0;
    color: var(--muted);
    font-size: 13px;
    line-height: 1.5;
  }

  .close-button {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    width: 38px;
    height: 38px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;

    background: #fff;
    color: #64748b;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .close-button:hover {
    background: #fff1f2;
    border-color: #fecdd3;
    color: #e11d48;
    transform: rotate(4deg);
  }

  .section-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin: 25px 0 16px;
  }

  .section-heading h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 750;
    color: #1e293b;
  }

  .section-heading p {
    margin: 5px 0 0;
    font-size: 12px;
    color: var(--muted);
  }

  .selection-counter {
    flex-shrink: 0;
    padding: 7px 11px;
    border-radius: 20px;
    background: #f1f5f9;
    color: #475569;
    font-size: 11px;
    font-weight: 700;
  }

  .desfecho-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
  }

  .desfecho-card {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;

    width: 100%;
    min-height: 70px;
    padding: 12px;

    text-align: left;
    border: 1px solid #e2e8f0;
    border-radius: 13px;
    background: #fff;

    color: #334155;
    cursor: pointer;
    font-family: inherit;

    transition:
      background 0.18s ease,
      border-color 0.18s ease,
      box-shadow 0.18s ease,
      transform 0.18s ease;
  }

  .desfecho-card:hover {
    border-color: var(--card-border);
    background: var(--card-bg);
    transform: translateY(-2px);
    box-shadow: 0 5px 14px rgba(15, 23, 42, 0.05);
  }

  .desfecho-card:focus-visible,
  .close-button:focus-visible,
  .cancel-button:focus-visible {
    outline: 3px solid #93c5fd;
    outline-offset: 3px;
  }

  .card-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    width: 35px;
    height: 35px;
    border-radius: 10px;

    background: var(--card-bg);
    color: var(--card-color);
    font-size: 19px;
    font-weight: 700;

    transition: all 0.18s ease;
  }

  .card-label {
    flex: 1;
    min-width: 0;

    font-size: 12px;
    font-weight: 650;
    line-height: 1.45;
    overflow-wrap: anywhere;
  }

  .card-check {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    width: 19px;
    height: 19px;
    border: 1px solid #dbe3ed;
    border-radius: 50%;

    color: #fff;
    font-size: 9px;
  }

  .desfecho-card.selected {
    border: 1.5px solid var(--card-color);
    background: var(--card-bg);
    box-shadow: 0 0 0 2px var(--card-bg);
  }

  .desfecho-card.selected .card-icon {
    background: var(--card-color);
    color: #fff;
  }

  .desfecho-card.selected .card-label {
    color: var(--card-color);
    font-weight: 800;
  }

  .desfecho-card.selected .card-check {
    border-color: var(--card-color);
    background: var(--card-color);
  }

  .date-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;

    margin-top: 25px;
    padding: 18px;
    border: 1px solid #e5eaf2;
    border-radius: 14px;
    background: #f8fafc;
  }

  .date-label {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .date-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    width: 42px;
    height: 42px;
    border-radius: 12px;

    background: #eaf0ff;
    color: var(--primary);
    font-size: 17px;
  }

  .date-label label {
    display: block;
    margin: 0;
    color: #1e293b;
    font-size: 13px;
    font-weight: 750;
  }

  .date-label p {
    margin: 4px 0 0;
    color: var(--muted);
    font-size: 11px;
  }

  .date-section input[type="date"] {
    width: 220px;
    max-width: 100%;
    min-height: 42px;
    padding: 9px 12px;

    border: 1px solid #dbe3ed;
    border-radius: 10px;
    outline: none;

    background: #fff;
    color: #334155;
    font: inherit;
    font-size: 13px;

    transition: border-color 0.2s, box-shadow 0.2s;
  }

  .date-section input[type="date"]:focus {
    border-color: #5578ca;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;

    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #edf1f7;
  }

  .cancel-button {
    min-height: 43px;
    padding: 0 20px;

    border: 1px solid #dbe3ed;
    border-radius: 10px;
    background: #fff;

    color: #475569;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .cancel-button:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
  }

  .save-button {
    min-height: 43px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 9px;

    border: 1px solid var(--primary);
    border-radius: 10px;
    background: var(--primary);

    color: #fff;
    font-size: 13px;
    font-weight: 750;

    box-shadow: 0 4px 10px rgba(12, 43, 110, 0.16);
    transition: all 0.2s ease;
  }

  .save-button:hover {
    background: #17449b;
    border-color: #17449b;
    box-shadow: 0 6px 16px rgba(12, 43, 110, 0.22);
    transform: translateY(-1px);
  }

  .save-button:focus {
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
  }

  .error-alert {
    margin: 18px 0 0;
    border-radius: 10px;
    font-size: 13px;
  }

  .success-alert {
    margin: 25px 0;
    padding: 24px;
    text-align: center;
    border-radius: 14px;
    line-height: 2;
  }

  @media (max-width: 700px) {
    padding: 22px;
    width: calc(100vw - 24px);
    max-height: 92vh;
    border-radius: 16px;

    .desfecho-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px;
    }

    .desfecho-card {
      min-height: 68px;
      padding: 9px;
      gap: 8px;
    }

    .card-icon {
      width: 30px;
      height: 30px;
      font-size: 16px;
    }

    .card-label {
      font-size: 11px;
    }

    .date-section {
      align-items: stretch;
      flex-direction: column;
      gap: 14px;
    }

    .date-section input[type="date"] {
      width: 100%;
    }
  }

  @media (max-width: 420px) {
    padding: 16px;

    .modal-header {
      gap: 10px;
      padding-bottom: 18px;
    }

    .header-icon {
      width: 40px;
      height: 40px;
      border-radius: 12px;
    }

    .header-content h2 {
      font-size: 20px;
    }

    .header-content p {
      font-size: 11px;
    }

    .eyebrow {
      font-size: 9px;
    }

    .close-button {
      width: 32px;
      height: 32px;
    }

    .section-heading {
      align-items: flex-start;
      flex-direction: column;
      gap: 8px;
    }

    .desfecho-grid {
      grid-template-columns: 1fr;
    }

    .desfecho-card {
      min-height: 58px;
      padding: 10px;
    }

    .card-label {
      font-size: 12px;
    }

    .modal-footer {
      flex-direction: column-reverse;
      align-items: stretch;
    }
      .selection-counter.has-selection {
  color: #0c2b6e;
  background: #eaf0ff;
  border: 1px solid #c7d7ff;
}

    .cancel-button,
    .save-button {
      width: 100%;
    }
  }
`;

export const StepTexth4 = styled.h3`
  margin: 0;
  text-align: center;
  color: #0c2b6e;
`;

export const StepContainer = styled.div`
  margin: 10px 0;
  justify-content: center;
  width: 100%;
`;

export const ButtonNext = styled(Button)`
  min-height: 42px;
  padding: 10px 24px;
  border: none;
  border-radius: 10px;
  background-color: #0c2b6e;
  font-size: 14px;
  font-weight: 700;

  &:hover {
    background-color: #17449b;
  }
`;

